import React, { createContext, useState, useContext, useEffect } from 'react';
import { getNotifications } from 'services/apiService';
import SecureLS from 'secure-ls';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [unreadNotifs, setUnreadNotifs] = useState([]);
  const [hasUnreadNotif, setHasUnreadNotif] = useState(false);
  const [ls] = useState(() => new SecureLS({ encodingType: 'aes' }));

  const fetchUnreadNotifications = async token => {
    try {
      const response = await getNotifications(token, {
        limit: 20,
        unreadOnly: 1,
      });
      let unreadData = [];
      if (response.success) {
        if (Array.isArray(response.data?.data)) {
          unreadData = response.data.data;
        } else if (Array.isArray(response.data)) {
          unreadData = response.data;
        }
      }
      setUnreadNotifs(unreadData);
      setHasUnreadNotif(unreadData.length > 0);
    } catch (error) {
      console.error('Error fetching unread notifications:', error);
      setUnreadNotifs([]);
      setHasUnreadNotif(false);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        unreadNotifs,
        hasUnreadNotif,
        setUnreadNotifs,
        setHasUnreadNotif,
        fetchUnreadNotifications,
      }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    return {
      unreadNotifs: [],
      hasUnreadNotif: false,
      setUnreadNotifs: () => {},
      setHasUnreadNotif: () => {},
      fetchUnreadNotifications: async () => {},
    };
  }
  return context;
};
